export const addThousandSeparator = (value: string): string =>
  value.replace(/\d[\d ]*\d|\d/g, run =>
    run.replace(/ /g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' '),
  );

export const removeThousandSeparator = (value: string): string =>
  value.replace(/\s/g, '');
